import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=6570f6b3&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=6570f6b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570f6b3",
  null
  
)

export default component.exports